import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { Nav, NavDropdown, MenuItem } from "react-bootstrap";

import { Url } from '../../shared/Url';
import Post from '../../shared/Post';
import MenuItems from './MenuItems'
import { ChkAdmisiones } from "../../funciones/AdmisionFunction";
let status = 0;
let peticion1 = false;
class HeaderSession extends Component {

  state = {
    userMenu: "open",
    status: 0,
    user: "",
    pull: true,
  }

  constructor (props) {
    super (props);
    this.consultaDatos();
    
  }

  componentWillMount = () => {
    if (peticion1 === true) return null;

    peticion1 = true
    ChkAdmisiones((resp) => {
      peticion1 = false
    });
  }

  consultaDatos = () => {
    let leerCookie = (nombre) => {
      let lista = document.cookie.split(";");
      let micookie;
      let igual;
      let valor;
      for (let i in lista) {
        let busca = lista[i].search(nombre);
        if (busca > -1) {micookie=lista[i]}
      }
      
      if (micookie === undefined) return null;
      
      igual = micookie.indexOf("=");
      valor = micookie.substring(igual + 1);
      return valor;
    }

  let valor = leerCookie("S_ID")
  let valor2 = leerCookie("U_ID");
  
    /* let valor = "";
    let valor2 = "";
    let lista = document.cookie.split(";");
    for (let i = 0; i <= lista.length; i++){
        if (lista[i] !== undefined) {
            let item = lista[i].split("=");
            if (item[0] === " S_ID"){
                valor = item[1];
            }else if (item[0] === " U_ID"){
              valor2 = item[1];
            }
        }
    } */

    let Content = {
        sId: valor,
        uId: valor2,
    }

    Post(`${Url}session`, Content, (resp) => {
      let data = JSON.parse(resp);
      if(data.status === 1) {
        status= 1
        this.setState ({status: 1});
      }
      if(data.status === 2){
        status= 2
        this.setState ({
          status: 2,
          user: data.user_002,
        });
      }
      
    });
  }

  icono = () => {
    switch (status) {
      case 0:
        return (
          <React.Fragment>
              <a><span style={{fontSize:13}} className="fuente-monserrat"><i className="fa fa-spinner fa-spin"></i> ESPERE...</span></a>
          </React.Fragment>
        );
      case 1:
        return (
          <React.Fragment>
              <a><span style={{fontSize:13}} className="fuente-monserrat"><i className="fa fa-user"></i> INICIA SESIÓN</span></a>
          </React.Fragment>
        );
      case 2:
        return (
          <React.Fragment >
              <a><span style={{fontSize:13}} className="fuente-monserrat"> <i className="fa fa-user"></i> {this.state.user}</span></a>
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
              <a><span style={{fontSize:13}} className="fuente-monserrat"><i className="fa fa-spinner fa-spin"></i> ESPERE...</span></a>
          </React.Fragment>
        );
    }
  }

  render() {
    switch (status) {
      case 0:
        return (
          <div>
            <MenuItems />
            {/* <Nav pullRight>
              <NavDropdown
                eventKey={2}
                title={this.icono()}
                id="basic-nav-dropdown-right"
              >
                <MenuItem eventKey={2.1} style= {{padding: 8}}>
                    <a className="fuente-monserrat"><i className="pe-7s-check"></i> ESPERE POR FAVOR...</a>
                </MenuItem>
              </NavDropdown>
            </Nav> */}
          </div>
        );
      case 1:
        return (
          <div style={{marginTop:5}}>
            <MenuItems />
            <Nav pullRight={this.props.right}>
              <NavDropdown
                eventKey={2}
                title={this.icono()}
                /* id="basic-nav-dropdown-right" */
              >
                <MenuItem eventKey={2.1} style= {{padding: 8}}>
                    <NavLink to="/login">
                      <a className="fuente-monserrat"><i className="pe-7s-check"></i> Inicia Sesión</a>
                      <div style = {{fontSize: 9}} align = "center">Estudiantes y Profesores</div>
                    </NavLink>
                </MenuItem>
                {/* <div style= {{paddingLeft: 24, paddingRight:24, paddingBottom: 10}}>
                  <a href = "https://iudlm.terna.net/RegistroNuevoIngreso.php?mid=0" target="_self"><i className="pe-7s-check"></i> Aspirantes</a>
                </div> */}
                {/* <div style= {{paddingLeft: 24, paddingRight:24, paddingBottom: 20}}>
                  <a href = "https://iudlm.terna.net/RegistroNuevoIngreso.php?mid=0" target="_self"><i className="pe-7s-check"></i> Registrarte</a>
                </div> */}
                <MenuItem eventKey={2.2} style= {{padding: 8}}>
                    <NavLink to="/registro"><a className="fuente-monserrat"><i className="pe-7s-add-user"></i> Registrate</a></NavLink>
                </MenuItem>
              </NavDropdown>
            </Nav>
          </div>
        );
      case 2:
        return (
          <div style={{marginTop:5}}>
            <MenuItems />
            <Nav pullRight={this.props.right}>
              <NavDropdown
                eventKey={2}
                title={this.icono()}
                id="basic-nav-dropdown-right"
              >
                <MenuItem eventKey={2.1} style= {{padding: 8}}>
                    <NavLink to="/Noticias"><a className="fuente-monserrat"><i className="pe-7s-study"></i> Mi Cuenta</a></NavLink>
                </MenuItem>
                <MenuItem eventKey={2.2} style= {{padding: 8}}>
                    <NavLink to="/Noticias"><a className="fuente-monserrat"><i className="pe-7s-power"></i> Cierra Sesión</a></NavLink>
                </MenuItem>
              </NavDropdown>
            </Nav>
          </div>
        );
      default:
        return (<div></div>)
    }
  }
}
 
export default HeaderSession;


// WEBPACK FOOTER //
// ./src/site/Componentes/HeaderSession.jsx